// extracted by mini-css-extract-plugin
module.exports =  {"wizardContainer":"DigitalWizardPageWithTitleTemplate_wizardContainer__3g6gz"};